export const tips: string[] = [
  'Не волнуйтесь, если забыли ввести трату. Просто ведите учёт дальше',
  'Не беспокойтесь, если суммы в жизни и приложении разные — даже примерный бюджет полезен',
  'Продолжайте записывать траты, даже если превысили дневную норму. Это случается со всеми',
  'Привычка отслеживать траты не вырабатывается мгновенно. Просто продолжайте',
];
